import { Messages } from '../../../../codegen/Localize';

import { DatabasesDisplayGridRowData } from '@tableau/data-catalog-client-components';
import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { groupDatabasesAction } from '../../../actions/spaces/GroupDatabasesAction';
import { CompositeSessionInfoSelectors } from '../../../selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const GroupDatabasesAction: IEntityAction<DatabasesDisplayGridRowData, {}> = {
  name: EntityActionNames.GroupDatabases,
  translateName: Messages.groupDatabases_action,
  isVisible: (_, state) => CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state) &&
      FeatureFlags.mergeDedupeDatabasesEnabled && selectCatalogingOnSiteEnabled(state),
  isClickable: (_, items) => items.length > 1 && items.every(item => item.connectionType === items[0].connectionType),
  createReduxAction: (items: DatabasesDisplayGridRowData[]) => {
    return groupDatabasesAction(items);
  }
};
